/*
 * Author: Harper Yan
 * File Created:   dnesday, 24-07-10 02:50 pm  * Last Modified: Wednesday, 24-07-10 02:50 pm, by Harper Yan
 */
import { Logger } from '@web/utils';

export const logger = new Logger({
  module: '@ucard/ds',
  prefix: 'DS/Dialog',
});

export const uid = (len = 8): string => {
  const buf: string[] = [];
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charlen = chars.length;

  for (let i = 0; i < len; i++) {
    buf[i] = chars.charAt(Math.floor(Math.random() * charlen));
  }

  return buf.join('');
};
